import React from 'react';
import { COCKPIT_ROLES, COCKPIT_STAFF_USERS } from './cockpit-data.jsx';
import { Icon } from './icons.jsx';
// Cockpit: Tab Usuários e Acessos

// ── OwnerCard ────────────────────────────────────────────────────────────────
const OwnerCard = ({ user, onToast }) => (
  <div className="card" style={{ marginBottom: 16 }}>
    <div className="card-head">
      <Icon name="userCheck" size={15} style={{ color: 'var(--text-muted)' }} />
      <h3>Owner / Admin principal</h3>
    </div>
    <div style={{ padding: '16px 20px', display: 'flex', gap: 16, alignItems: 'flex-start', flexWrap: 'wrap' }}>
      <div style={{ width: 48, height: 48, borderRadius: 12, background: 'var(--brand-navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 700, fontSize: 16, flexShrink: 0 }}>
        {user.name.split(' ').slice(0, 2).map(w => w[0]).join('')}
      </div>
      <div style={{ flex: 1, minWidth: 200 }}>
        <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 4 }}>{user.name}</div>
        <div style={{ display: 'flex', gap: 14, fontSize: 12, color: 'var(--text-muted)', flexWrap: 'wrap' }}>
          <span style={{ fontFamily: 'JetBrains Mono, monospace' }}>{user.email}</span>
          <span>·</span>
          <span>Último acesso: {user.lastAccess}</span>
          <span>·</span>
          <span>MFA: {user.mfa ? <span style={{ color: 'var(--success)', fontWeight: 600 }}>Ativo</span> : <span style={{ color: 'var(--warning)', fontWeight: 600 }}>Inativo</span>}</span>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
        <button className="btn sm" onClick={() => onToast('E-mail de redefinição enviado para ' + user.email)}>
          <Icon name="key" size={13} />Resetar senha
        </button>
        <button className="btn sm" onClick={() => onToast('Convite reenviado para ' + user.email)}>
          <Icon name="mail" size={13} />Reenviar convite
        </button>
        <button className="btn sm primary" onClick={() => onToast('Abrindo sessão como ' + user.name + '…')}>
          <Icon name="switchUser" size={13} />Abrir como usuário
        </button>
      </div>
    </div>
  </div>
);

// ── StaffTable ────────────────────────────────────────────────────────────────
const StaffTable = ({ users, onToast }) => {
  const [actionUser, setActionUser] = React.useState(null);
  const [confirmModal, setConfirmModal] = React.useState(null);

  const handleAction = (label, user) => {
    const msgs = {
      'Resetar senha':  `E-mail de redefinição enviado para ${user.email}`,
      'Forçar logout':  `Sessão de ${user.name} encerrada`,
      'Inativar':       `${user.name} desativado`,
      'Reativar':       `${user.name} reativado`,
      'Ver permissões': `Abrindo permissões de ${user.name}…`,
    };
    onToast(msgs[label] || `Ação "${label}" executada para ${user.name}`);
    setActionUser(null);
  };

  return (
    <div className="card">
      <div className="card-head">
        <Icon name="users" size={15} style={{ color: 'var(--text-muted)' }} />
        <h3>Usuários staff do tenant</h3>
        <span className="sub">{users.length} usuários</span>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="data" style={{ minWidth: 700 }}>
          <thead>
            <tr>
              <th>Usuário</th>
              <th>Role</th>
              <th>Status</th>
              <th>Último acesso</th>
              <th>MFA</th>
              <th style={{ textAlign: 'right' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u, i) => (
              <tr key={i} style={{ position: 'relative' }}>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 30, height: 30, borderRadius: 8, background: u.isOwner ? 'var(--brand-navy)' : 'var(--bg-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: u.isOwner ? 'white' : 'var(--text-secondary)', flexShrink: 0 }}>
                      {u.name.split(' ').slice(0, 2).map(w => w[0]).join('')}
                    </div>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 500 }}>{u.name}{u.isOwner && <span style={{ marginLeft: 6, fontSize: 10, fontWeight: 700, background: 'var(--info-bg)', color: 'var(--info)', padding: '2px 6px', borderRadius: 4 }}>Owner</span>}</div>
                      <div style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: 'JetBrains Mono, monospace' }}>{u.email}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)' }}>{u.role}</span>
                </td>
                <td>
                  <span className={'badge ' + (u.status === 'ativo' ? 'success' : 'neutral')}>
                    <span className="dot" />
                    {u.status === 'ativo' ? 'Ativo' : 'Inativo'}
                  </span>
                </td>
                <td style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{u.lastAccess}</td>
                <td>
                  {u.mfa
                    ? <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--success)' }}>Ativo</span>
                    : <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>—</span>}
                </td>
                <td>
                  <div className="row-actions">
                    <button className="icon-action" title="Resetar senha" onClick={() => handleAction('Resetar senha', u)}>
                      <Icon name="key" size={14} />
                    </button>
                    <button className="icon-action" title="Forçar logout" onClick={() => handleAction('Forçar logout', u)}>
                      <Icon name="lock" size={14} />
                    </button>
                    <button className="icon-action" title={u.status === 'ativo' ? 'Inativar' : 'Reativar'} onClick={() => handleAction(u.status === 'ativo' ? 'Inativar' : 'Reativar', u)}>
                      <Icon name={u.status === 'ativo' ? 'suspend' : 'play'} size={14} />
                    </button>
                    <button className="icon-action" title="Ver permissões" onClick={() => handleAction('Ver permissões', u)}>
                      <Icon name="search" size={14} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// ── RolesSection ──────────────────────────────────────────────────────────────
const RolesSection = ({ roles, onToast }) => (
  <div className="card" style={{ marginTop: 16 }}>
    <div className="card-head">
      <Icon name="shield" size={15} style={{ color: 'var(--text-muted)' }} />
      <h3>Roles do tenant</h3>
      <span className="sub">{roles.length} roles configuradas</span>
      <div className="actions">
        <button className="btn ghost sm" onClick={() => onToast('Permissões sincronizadas com o plano Pro')}>
          <Icon name="refresh" size={13} />Sincronizar com plano
        </button>
      </div>
    </div>
    <div style={{ padding: '8px 0' }}>
      {roles.map((role, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '10px 20px', borderBottom: i < roles.length - 1 ? '1px solid var(--border)' : 'none' }}>
          <div style={{ width: 30, height: 30, borderRadius: 7, background: role.name === 'Owner' ? 'var(--brand-navy)' : 'var(--bg-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon name="users" size={14} style={{ color: role.name === 'Owner' ? 'white' : 'var(--text-muted)' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 600 }}>{role.name}</div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{role.permissions} rotas permitidas · {role.users} {role.users === 1 ? 'usuário' : 'usuários'}</div>
          </div>
          <span className="badge success" style={{ fontSize: 10 }}>
            <span className="dot" />Sincronizado
          </span>
          <button className="icon-action" title="Ver permissões" onClick={() => onToast(`Abrindo permissões de ${role.name}…`)}>
            <Icon name="search" size={14} />
          </button>
        </div>
      ))}
    </div>
  </div>
);

// ── CockpitUsersTab ───────────────────────────────────────────────────────────
const CockpitUsersTab = ({ cockpitData, onToast }) => {
  const owner = (cockpitData?.staffUsers || COCKPIT_STAFF_USERS).find(u => u.isOwner);
  return (
    <div>
      {owner && <OwnerCard user={owner} onToast={onToast} />}
      <StaffTable users={(cockpitData?.staffUsers || COCKPIT_STAFF_USERS)} onToast={onToast} />
      <RolesSection roles={(cockpitData?.roles || COCKPIT_ROLES)} onToast={onToast} />
    </div>
  );
};

export {
  CockpitUsersTab,
};
